import { useCallback, useEffect } from 'react'
import { Errcode } from 'src/constants/errcode'
import { Cmdtypes } from 'src/constants/cmdtypes'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { setModalItems, setCloseModal } from 'src/store/Reducer/common/modalSlice'
import { ResponseDataBody, ResponseDataType } from 'src/types/websocket'
import { eventBus } from 'src/api/eventBus'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const useExplorerDeleteEventBus = () => {
  const dispatch = useAppDispatch()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const handleExplorerDeleteDataResponse = useCallback(
    (message: ResponseDataType<ResponseDataBody.ExplorerDeleteData>) => {
      const { Header, Body } = message.responseData

      dispatch(setCloseModal())

      if (Header.ErrCode === Errcode.SUCCESS) {
        if (Body.Result) {
          dispatch(
            setModalItems({
              type: 'alert',
              text: t('MODAL.DELETE_DATA.SUCCESS', {
                defaultValue: 'Data deleted successfully.',
              }) as string,
              confirmFunc: () => {
                navigate('/home')
              },
            }),
          )
        } else {
          dispatch(
            setModalItems({
              type: 'alert',
              text: t('MODAL.BACK_UP.DELETE_DATA', {
                defaultValue: 'Failed to delete data.',
              }) as string,
              confirmFunc: () => {
                window.location.reload()
              },
            }),
          )
        }
      } else console.error(Header)
    },
    [dispatch, t, navigate],
  )

  useEffect(() => {
    const ExplorerDeleteDataResponseListener =
      eventBus.subscribe<ResponseDataBody.ExplorerDeleteData>(
        Cmdtypes.EXPLORER_DATA_DELETE,
        handleExplorerDeleteDataResponse,
      )
    return () => {
      ExplorerDeleteDataResponseListener.unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, handleExplorerDeleteDataResponse])
}

export default useExplorerDeleteEventBus
